import React from 'react';

export interface IBookingLinkContext {
  isEnabled: boolean;
}
/**
 * @todo use `createRequiredContext`
 */
export const BookingLinkContext = React.createContext<IBookingLinkContext>({
  isEnabled: false,
});

BookingLinkContext.displayName = 'BookingLinkContext';
